<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Loan amount and fees</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row">
      <div class="col-sm-5 offset-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Purchase / Refinance amount (inc GST)</mat-label>
          <input matInput placeholder="Purchase / Refinance amount (inc GST)" type="number" formControlName="purchaseRefinanceAmount">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'purchaseRefinanceAmount'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5 offset-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Deposit / Trade Amount</mat-label>
          <input matInput placeholder="Deposit / Trade Amount" type="number" formControlName="depositTradeAmount">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'depositTradeAmount'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="hasSettlement">
      <div class="col-sm-5 offset-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Amount to be paid upfront</mat-label>
          <input matInput placeholder="Amount to be paid upfront" type="number" formControlName="amountPaid">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'amountPaid'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5 offset-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Subtotal</mat-label>
          <input matInput placeholder="Subtotal" type="number" formControlName="subTotal" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'subTotal'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="!lcaOriginator">
      <div class="col-sm-5 offset-sm-1">
        <mat-checkbox formControlName="originationFeeCheck" class="d-flex" (change)="checkOrigBrokerFees()">No origination fee</mat-checkbox>
        <mat-error>
          <app-validation-partial
            [formGroup]="formGroup"
            [fieldName]="'originationFeeCheck'"
          ></app-validation-partial>
        </mat-error>
      </div>
      <div class="col-sm-5">
        <mat-form-field appearance="outline">
          <mat-label>Origination fee (inc GST)</mat-label>
          <input matInput placeholder="Origination fee (inc GST)" type="number" formControlName="originationFee">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
  <!--          <app-validation-partial-->
  <!--            [formGroup]="formGroup"-->
  <!--            [fieldName]="'originationFee'"-->
  <!--          ></app-validation-partial>-->
            <span *ngIf="formGroup.get('originationFee')?.errors?.min">Must be more than $0</span>
            <span *ngIf="formGroup.get('originationFee')?.errors?.errors?.includes('fee-exceeds-maximum')">
              {{ formGroup.get('originationFee')?.errors?.message }}
            </span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5 offset-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Application fee</mat-label>
          <input matInput placeholder="Application fee" type="number" formControlName="applicationFee" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'applicationFee'"
            ></app-validation-partial>
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <!-- Insurances -->
    <div class="row">
      <div class="col-sm-12">
        <app-insurance
          [insurancesFormArray]="formGroup.controls.insurances"
          [insuranceList]="allInsurances"
          (totalInsuranceAmountChange)="handleInsurancesChange($event)">
        </app-insurance>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-5 offset-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Subtotal + fees</mat-label>
          <input matInput placeholder="Subtotal + fees" type="number" formControlName="subtotalWithFees" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error style="font-size: xx-small">
            Insurances must not reach 10% of purchase price
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row" *ngIf="!hideBrokerage && !lcaOriginator">
      <div class="col-sm-5 offset-sm-1">
        <mat-form-field appearance="outline">
          <mat-label>Brokerage percentage (inc GST)</mat-label>
          <input matInput placeholder="Brokerage percent (inc GST)" type="number" formControlName="brokerageFeePercentage" ng-model='val | number: 2'>
          <span matSuffix>%</span>
          <mat-error>
  <!--          <span *ngIf="formGroup.get('brokerageFeePercentage')?.errors?.max">-->
  <!--            Brokerage percentage must be less than {{maxBrokeragePercent}}%-->
  <!--          </span>-->
          </mat-error>
        </mat-form-field>
        <mat-checkbox formControlName="brokerageFeeCheck" (change)="toggleBrokerageFees($event.checked)">No brokerage fee</mat-checkbox>
        <mat-error>
          <app-validation-partial [formGroup]="formGroup" [fieldName]="'brokerageFeeCheck'"></app-validation-partial>
        </mat-error>
        <!-- Dial Down Enabled - {{dialDownEnabled}} -->
        <mat-checkbox formControlName="brokerageFeeCapitalizedCheck" (change)="toggleDialDown($event.checked)">Capitalise brokerage</mat-checkbox>
      </div>
      <div class="col-sm-5">
        <mat-form-field appearance="outline">
          <mat-label>Brokerage amount (inc GST)</mat-label>
          <input matInput placeholder="Brokerage amount (inc GST)" type="number" formControlName="brokerageFee">
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <app-validation-partial
              [formGroup]="formGroup"
              [fieldName]="'brokerageFee'"
            ></app-validation-partial>
            <span *ngIf="formGroup.get('brokerageFee')?.errors?.max">&nbsp;- Max brokerage amount: ${{rateData?.MaxBrokerageAmountAvailable}}</span>
          </mat-error>
        </mat-form-field>
        <small *ngIf="formGroup.get('brokerageFee')?.value < 100 && formGroup.get('brokerageFee')?.value > 0" class="text-danger" style="top: -15px; position: relative;">Brokerage entered is low. Please check the amount entered.</small>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-5 offset-sm-6">
        <mat-form-field appearance="outline">
          <mat-label>Total loan amount</mat-label>
          <input matInput placeholder="Total loan amount" type="number" formControlName="totalLoanAmount" readonly>
          <span matPrefix>$&nbsp;</span>
          <span matSuffix>.00</span>
          <mat-error>
            <ng-container *ngIf="(formGroup.get('totalLoanAmount')?.invalid && (formGroup.get('totalLoanAmount')?.dirty || formGroup.get('totalLoanAmount')?.touched))  || (formGroup.get('totalLoanAmount')?.errors)">

              <span *ngIf="formGroup.get('totalLoanAmount')?.errors?.required">This field is required</span>

              <ng-container *ngIf="!formGroup.get('totalLoanAmount')?.errors?.required">

                <span *ngIf="formGroup.get('totalLoanAmount')?.errors.min">Must be greater than supplied value</span>

                <span *ngIf="formGroup.get('totalLoanAmount')?.errors.max">
                  Maximum Loan Amount should be ${{formGroup.get('totalLoanAmount')?.errors.max.max}}
                </span>

              </ng-container>
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
